export const featurebaseQueryKeys = {
  JWT_TOKEN: 'jwt-token'
}
